import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

export const MultasEuModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
  const handleContactClick = () => {
    onClose();
    onOpenContactModal('Consulta sobre Multas.EU');
  };
  
  return (
    <ModalBase 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Multas.EU - Defensa de Sanciones"
      headerClassName="bg-blue-100 border-blue-200"
      titleClassName="text-blue-800"
    >
      <p className="mb-6">
        En Multas.EU, ofrecemos una defensa legal integral contra sanciones de tráfico en toda Europa. Nuestro equipo de expertos conoce a fondo las legislaciones específicas de cada país, garantizando la mejor estrategia para recurrir y gestionar tus multas. Tu tranquilidad es nuestra prioridad.
      </p>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Cobertura Completa de Sanciones</h3>
        <p>Gestionamos una amplia variedad de infracciones para que no tengas que preocuparte por nada:</p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li><strong>Multas por Exceso de Velocidad:</strong> Analizamos la legalidad del radar y el procedimiento sancionador.</li>
          <li><strong>Multas de Aparcamiento:</strong> Verificamos la señalización, la normativa municipal y posibles defectos de forma.</li>
          <li><strong>Sanciones por Alcoholemia y Drogas:</strong> Asesoramiento experto desde el primer momento, crucial para una defensa exitosa.</li>
          <li><strong>Uso del Móvil y Otras Distracciones:</strong> Recurrimos multas por distracciones al volante basándonos en la falta de pruebas concluyentes.</li>
          <li><strong>Sanciones de Transporte Profesional:</strong> Tacógrafos, tiempos de conducción y descanso, carga y estiba.</li>
          <li><strong>Multas en el Extranjero:</strong> Nos encargamos de las notificaciones y recursos de multas recibidas en cualquier país de la UE.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestro Proceso Simplificado</h3>
        <ol className="list-decimal list-inside mt-2 space-y-2">
          <li><strong>Nos envías la multa:</strong> Puedes hacerlo a través de nuestro formulario de contacto, adjuntando una foto o el documento escaneado.</li>
          <li><strong>Análisis Gratuito:</strong> Nuestro equipo legal estudia la viabilidad del recurso sin ningún coste ni compromiso.</li>
          <li><strong>Recurrimos por ti:</strong> Si decides seguir adelante, nos encargamos de toda la burocracia, redactando y presentando los escritos necesarios.</li>
          <li><strong>Seguimiento Constante:</strong> Te mantenemos informado en cada paso del proceso hasta la resolución final.</li>
        </ol>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-gray-700 mb-3">¿Por Qué Elegir Multas.EU?</h3>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li><strong>Experiencia Paneuropea:</strong> Años de experiencia defendiendo a conductores en diferentes jurisdicciones europeas.</li>
          <li><strong>Alta Tasa de Éxito:</strong> Nuestro conocimiento especializado nos permite ganar un alto porcentaje de los casos.</li>
          <li><strong>Transparencia Total:</strong> Precios claros y sin sorpresas. Sabrás desde el principio cuánto te costará el servicio.</li>
          <li><strong>Comodidad:</strong> Gestiona todo el proceso online, desde la comodidad de tu casa.</li>
        </ul>
      </section>

      <div className="mt-8 pt-6 border-t border-gray-200 flex justify-end">
        <Button onClick={handleContactClick} variant="primary" size="large">
          Consultar mi Multa
        </Button>
      </div>
    </ModalBase>
  );
};
